import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=28245454"
import script from "./GroupModal.vue?vue&type=script&lang=ts"
export * from "./GroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28245454')) {
      api.createRecord('28245454', component.options)
    } else {
      api.reload('28245454', component.options)
    }
    module.hot.accept("./GroupModal.vue?vue&type=template&id=28245454", function () {
      api.rerender('28245454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/customer-group/GroupModal.vue"
export default component.exports